import { render, staticRenderFns } from "./DialogRedirect.vue?vue&type=template&id=3aeb3a94"
import script from "./DialogRedirect.vue?vue&type=script&lang=js"
export * from "./DialogRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports